export const ingredients = [
  { name: 'abborre' },
  { name: 'after eight' },
  { name: 'ajvar relish' },
  { name: 'alfalfagroddar' },
  { name: 'ananas' },
  { name: 'ananasjuice' },
  { name: 'anka' },
  { name: 'anka med skinn' },
  { name: 'ankbröst' },
  { name: 'ansjovis' },
  { name: 'apelsin' },
  { name: 'apelsinjuice' },
  { name: 'apelsinmarmelad' },
  { name: 'apelsinskal' },
  { name: 'aprikoser' },
  { name: 'aubergine' },
  { name: 'avokado' },
  { name: 'bacon' },
  { name: 'baguette' },
  { name: 'bakpulver' },
  { name: 'bambuskott' },
  { name: 'banan' },
  { name: 'basilika' },
  { name: 'basmatiris' },
  { name: 'bearnaisesås' },
  { name: 'björnbär' },
  { name: 'blodbröd' },
  { name: 'blodpudding' },
  { name: 'blomkål' },
  { name: 'bläckfisk' },
  { name: 'blåbär' },
  { name: 'blåmusslor' },
  { name: 'bondbönor' },
  { name: 'bostongurka' },
  { name: 'bovete' },
  { name: 'bovetemjöl' },
  { name: 'brieost' },
  { name: 'broccoli' },
  { name: 'brun farin' },
  { name: 'bruna bönor' },
  { name: 'brunkål' },
  { name: 'brysselkål' },
  { name: 'bulgur' },
  { name: 'böckling' },
  { name: 'böcklingpastej' },
  { name: 'camembert' },
  { name: 'cashewnötter' },
  { name: 'champinjoner' },
  { name: 'cherimoya' },
  { name: 'chilipeppar' },
  { name: 'chilisås' },
  { name: 'chokladsås' },
  { name: 'chorizo' },
  { name: 'chèvre' },
  { name: 'ciabatta' },
  { name: 'citron' },
  { name: 'citronskal' },
  { name: 'clementiner' },
  { name: 'couscous' },
  { name: 'creme fraiche' },
  { name: 'dadlar' },
  { name: 'dill' },
  { name: 'dinkel' },
  { name: 'druvkärnolja' },
  { name: 'durra' },
  { name: 'duva' },
  { name: 'endivesallat' },
  { name: 'entrecôte' },
  { name: 'falafel' },
  { name: 'falukorv' },
  { name: 'fasan' },
  { name: 'fefferoni' },
  { name: 'fetaost' },
  { name: 'fettfri majonnäs' },
  { name: 'fiberhavregryn' },
  { name: 'fikon' },
  { name: 'filmjölk' },
  { name: 'filodegplattor' },
  { name: 'fisk' },
  { name: 'fiskbuljong' },
  { name: 'flankstek' },
  { name: 'flintastek' },
  { name: 'flundra' },
  { name: 'fläsk' },
  { name: 'fläskbog' },
  { name: 'fläskfilé' },
  { name: 'fläskkarré' },
  { name: 'fläskkorv' },
  { name: 'fläskkotlett' },
  { name: 'fläsklägg' },
  { name: 'fransyska' },
  { name: 'friséesallat' },
  { name: 'frukostkorv' },
  { name: 'fusilli' },
  { name: 'fänkål' },
  { name: 'färskost' },
  { name: 'färskpotatis' },
  { name: 'gammaldags mjölk' },
  { name: 'getost' },
  { name: 'glasnudlar' },
  { name: 'grahamsmjöl' },
  { name: 'granatäpple' },
  { name: 'grapefrukt' },
  { name: 'gravad lax' },
  { name: 'gravlaxsås' },
  { name: 'grillkorv' },
  { name: 'grisfötter' },
  { name: 'grodlår' },
  { name: 'gräddfil' },
  { name: 'gräslök' },
  { name: 'grön paprika' },
  { name: 'gröna bönor' },
  { name: 'gröna linser' },
  { name: 'gröna ärter' },
  { name: 'grönkål' },
  { name: 'grönmögelost' },
  { name: 'grönsaksbuljong' },
  { name: 'grötris' },
  { name: 'gul lök' },
  { name: 'gul paprika' },
  { name: 'gula ärter' },
  { name: 'gurka' },
  { name: 'gädda' },
  { name: 'gås' },
  { name: 'gös' },
  { name: 'hallon' },
  { name: 'hallonsylt' },
  { name: 'halloumiost' },
  { name: 'hamburgerbröd' },
  { name: 'hare' },
  { name: 'hasselnötter' },
  { name: 'havredryck' },
  { name: 'havsabborre' },
  { name: 'havskräftor' },
  { name: 'havssalt' },
  { name: 'havtorn' },
  { name: 'hirs' },
  { name: 'hjort' },
  { name: 'hjortron' },
  { name: 'hoki' },
  { name: 'honung' },
  { name: 'honungsmelon' },
  { name: 'hp-sås' },
  { name: 'hummer' },
  { name: 'högrev' },
  { name: 'höna' },
  { name: 'hönsbuljong' },
  { name: 'höstpotatis' },
  { name: 'inlagd gurka' },
  { name: 'inlagd sill' },
  { name: 'isbergssallat' },
  { name: 'isterband' },
  { name: 'jasminris' },
  { name: 'joderat salt' },
  { name: 'jordgubbar' },
  { name: 'jordgubbssylt' },
  { name: 'jordnötssmör' },
  { name: 'jordnötter' },
  { name: 'jordärtskocka' },
  { name: 'kabanoss' },
  { name: 'kakaopulver' },
  { name: 'kalkon' },
  { name: 'kalkonfilé' },
  { name: 'kalvbog' },
  { name: 'kalvbringa' },
  { name: 'kalvbräss' },
  { name: 'kalvbuljong' },
  { name: 'kalvhögrev' },
  { name: 'kalvinnanlår' },
  { name: 'kantareller' },
  { name: 'kassler' },
  { name: 'katrinplommon' },
  { name: 'kaviar' },
  { name: 'kebabkött' },
  { name: 'keso' },
  { name: 'ketchup' },
  { name: 'kidneybönor' },
  { name: 'kikärter' },
  { name: 'kiwi' },
  { name: 'kokosfett' },
  { name: 'kokosflingor' },
  { name: 'kokosmjölk' },
  { name: 'kokosnöt' },
  { name: 'kokosvatten' },
  { name: 'kolja' },
  { name: 'kondenserad mjölk' },
  { name: 'konjak' },
  { name: 'korv' },
  { name: 'korvbröd' },
  { name: 'krabba' },
  { name: 'kranvatten' },
  { name: 'kronärtskocka' },
  { name: 'krossade tomater' },
  { name: 'krusbär' },
  { name: 'kräftor' },
  { name: 'kummel' },
  { name: 'kumquat' },
  { name: 'kvarg' },
  { name: 'kyckling' },
  { name: 'kycklingben' },
  { name: 'kycklingbröst' },
  { name: 'kycklingfilé' },
  { name: 'kycklinglår' },
  { name: 'kycklinglårfilé' },
  { name: 'kycklingvingar' },
  { name: 'kålrabbi' },
  { name: 'kålrot' },
  { name: 'körsbärstomater' },
  { name: 'köttbuljong' },
  { name: 'köttbullar' },
  { name: 'lammbog' },
  { name: 'lammbräss' },
  { name: 'lammfärs' },
  { name: 'lammstek' },
  { name: 'lasagneplattor' },
  { name: 'lax' },
  { name: 'leverpastej' },
  { name: 'lime' },
  { name: 'limejuice' },
  { name: 'linfrön' },
  { name: 'linfröolja' },
  { name: 'lingon' },
  { name: 'lingonsylt' },
  { name: 'linser' },
  { name: 'linsgroddar' },
  { name: 'ljus sirap' },
  { name: 'lutfisk' },
  { name: 'löjrom' },
  { name: 'lök' },
  { name: 'majonnäs' },
  { name: 'majrova' },
  { name: 'majsgryn' },
  { name: 'majskolv' },
  { name: 'majsmjöl' },
  { name: 'majsolja' },
  { name: 'makrill' },
  { name: 'mandariner' },
  { name: 'mandelmassa' },
  { name: 'mandelpotatis' },
  { name: 'mango' },
  { name: 'mangold' },
  { name: 'marulk' },
  { name: 'maräng' },
  { name: 'matjessill' },
  { name: 'matlagningsgrädde' },
  { name: 'medwurst' },
  { name: 'mellangrädde' },
  { name: 'mellanmjölk' },
  { name: 'mineralsalt' },
  { name: 'mineralvatten' },
  { name: 'mjukost' },
  { name: 'mjölk' },
  { name: 'mjölkchoklad' },
  { name: 'morot' },
  { name: 'morotsjuice' },
  { name: 'mozzarella' },
  { name: 'mungbönor' },
  { name: 'mungbönsgroddar' },
  { name: 'musslor' },
  { name: 'mâchesallat' },
  { name: 'måltidsersättning' },
  { name: 'mörk blockchoklad' },
  { name: 'nudlar' },
  { name: 'nässlor' },
  { name: 'nätmelon' },
  { name: 'nötbiff' },
  { name: 'nötfärs' },
  { name: 'nötgrytbitar' },
  { name: 'nötinnanlår' },
  { name: 'oliver' },
  { name: 'olivolja' },
  { name: 'ostbiff' },
  { name: 'ostron' },
  { name: 'oxbringa' },
  { name: 'oxfilé' },
  { name: 'oxsvans' },
  { name: 'palmolja' },
  { name: 'palsternacka' },
  { name: 'papaya' },
  { name: 'paprika' },
  { name: 'paradisäpplen' },
  { name: 'paranötter' },
  { name: 'parmesanost' },
  { name: 'passerade tomater' },
  { name: 'passionsfrukt' },
  { name: 'pasta' },
  { name: 'pekannötter' },
  { name: 'pepparrot' },
  { name: 'persika' },
  { name: 'persikor' },
  { name: 'pesto' },
  { name: 'piggvar' },
  { name: 'pilgrimsmusslor' },
  { name: 'pistaschnötter' },
  { name: 'pitabröd' },
  { name: 'plommon' },
  { name: 'portvin' },
  { name: 'potatis' },
  { name: 'potatischips' },
  { name: 'potatismjöl' },
  { name: 'prinskorv' },
  { name: 'pumpa' },
  { name: 'pumpafrön' },
  { name: 'punsch' },
  { name: 'purjolök' },
  { name: 'päron' },
  { name: 'quinoa' },
  { name: 'rabarber' },
  { name: 'rapsolja' },
  { name: 'regnbågslax' },
  { name: 'renbog' },
  { name: 'renkorv' },
  { name: 'renskav' },
  { name: 'renstek' },
  { name: 'revbensspjäll' },
  { name: 'rimmat sidfläsk' },
  { name: 'ripa' },
  { name: 'ris' },
  { name: 'romansallat' },
  { name: 'rotpersilja' },
  { name: 'rotselleri' },
  { name: 'rucolasallat' },
  { name: 'russin' },
  { name: 'rädisa' },
  { name: 'räkor' },
  { name: 'rättika' },
  { name: 'rådjursbog' },
  { name: 'rågmjöl' },
  { name: 'råris' },
  { name: 'röd lök' },
  { name: 'röd paprika' },
  { name: 'rödbetor' },
  { name: 'röding' },
  { name: 'rödkål' },
  { name: 'rödspätta' },
  { name: 'rödspättafilé' },
  { name: 'rödvin' },
  { name: 'rödvinbärsgelé' },
  { name: 'rökt lax' },
  { name: 'rökt skinka' },
  { name: 'salami' },
  { name: 'salladskål' },
  { name: 'salsiccia' },
  { name: 'salt sill' },
  { name: 'saltgurka' },
  { name: 'sardeller' },
  { name: 'sardiner' },
  { name: 'savojkål' },
  { name: 'sej' },
  { name: 'semla' },
  { name: 'senap' },
  { name: 'senapssill' },
  { name: 'sesamfrön' },
  { name: 'sesamolja' },
  { name: 'sherry' },
  { name: 'sidfläsk' },
  { name: 'skarpsill' },
  { name: 'skinka' },
  { name: 'småkakor' },
  { name: 'smör' },
  { name: 'smördeg' },
  { name: 'snabbkaffe' },
  { name: 'sniglar vinbergssnäckor' },
  { name: 'socker' },
  { name: 'sockerärter' },
  { name: 'sodavatten' },
  { name: 'soja' },
  { name: 'sojabönor' },
  { name: 'sojabönsgroddar' },
  { name: 'sojakorv' },
  { name: 'sojasås' },
  { name: 'solrosfrön' },
  { name: 'solrosolja' },
  { name: 'soltorkade tomater' },
  { name: 'sparris' },
  { name: 'spenat' },
  { name: 'squash' },
  { name: 'squashfrön' },
  { name: 'stenbitskaviar' },
  { name: 'stjälkselleri' },
  { name: 'stora vita bönor' },
  { name: 'strutsfilé' },
  { name: 'ströbröd' },
  { name: 'strömming' },
  { name: 'svagdricka' },
  { name: 'svamp' },
  { name: 'svarta bönor' },
  { name: 'svarta vinbär' },
  { name: 'svartrot' },
  { name: 'svartvinbärsgelé' },
  { name: 'sweet chilisås' },
  { name: 'syltlök' },
  { name: 'tacoskal' },
  { name: 'tagliatelle' },
  { name: 'tistelolja' },
  { name: 'tofu' },
  { name: 'tomat' },
  { name: 'tomatjuice' },
  { name: 'tomatketchup' },
  { name: 'tomatpuré' },
  { name: 'tonfisk' },
  { name: 'torkad banan' },
  { name: 'torsk' },
  { name: 'torskfilé' },
  { name: 'torskrygg' },
  { name: 'tortellini' },
  { name: 'trädgårdskrasse' },
  { name: 'valnötter' },
  { name: 'varmkorv' },
  { name: 'vattenkrasse' },
  { name: 'vattenmelon' },
  { name: 'vaxbönor' },
  { name: 'vetegroddar' },
  { name: 'vetegroddsolja' },
  { name: 'vetekli' },
  { name: 'vetekross' },
  { name: 'vetemjöl' },
  { name: 'vetetortilla' },
  { name: 'vildsvinfilé' },
  { name: 'vinäger' },
  { name: 'vispgrädde' },
  { name: 'vita bönor' },
  { name: 'vitkål' },
  { name: 'vitlök' },
  { name: 'vitt bröd' },
  { name: 'vitt vin' },
  { name: 'whisky' },
  { name: 'wienerkorv' },
  { name: 'wokgrönsaker' },
  { name: 'yoghurt' },
  { name: 'ädelost' },
  { name: 'ägg' },
  { name: 'äggnudlar' },
  { name: 'äggula' },
  { name: 'äggvita' },
  { name: 'älg' },
  { name: 'älgfärs' },
  { name: 'älghögrev' },
  { name: 'älgstek' },
  { name: 'äppelcidervinäger' },
  { name: 'äppeljuice' },
  { name: 'äppelmos' },
  { name: 'äpple' },
  { name: 'ärter' },
  { name: 'ättiksgurka' },
  { name: 'ättiksprit' },
  { name: 'ättikströmming' },
  { name: 'öl' },
  { name: 'öring' },
  { name: 'örtsalt' }
]

export const units = [
  {
    unit: 'g',
    min: 50,
    max: 500
  }, {
    unit: 'kryddmått',
    min: 1,
    max: 2
  },
  {
    unit: 'tsk',
    min: 1,
    max: 4
  }, {
    unit: 'msk',
    min: 1,
    max: 5
  }, {
    unit: 'dl',
    min: 1,
    max: 9
  }, {
    unit: 'st',
    min: 1,
    max: 100
  }, {
    unit: 'liter',
    min: 1,
    max: 10
  }, {
    unit: 'halv',
    min: 1,
    max: 1
  }, {
    unit: 'kg',
    min: 1,
    max: 3
  }, {
    unit: 'hink',
    min: 1,
    max: 1
  }
]

export const prepare = [
  'vispa',
  'tärna',
  'skiva',
  'hacka',
  'måtta',
  'slunga',
  'skala',
  'skaka',
  'blanda',
  'mixa',
  'plocka',
  'stompa',
  'mortla',
  'hyvla',
  'riv',
  'finhacka',
  'grovriv',
  'grovhacka',
  'strimla',
  'skär'
]

export const cook = [
  { action: 'stek',
    result: 'stekt'
  },
  {
    action: 'koka',
    result: 'kokt'
  }, {
    action: 'ånga',
    result: 'ångad'
  }, {
    action: 'sjud',
    result: 'sjuden'
  }, {
    action: 'rosta',
    result: 'rostad'
  }, {
    action: 'rök',
    result: 'rökt'
  }, {
    action: 'fritera',
    result: 'friterad'
  }, {
    action: 'grilla',
    result: 'grillad'
  }, {
    action: 'frys',
    result: 'fryst'
  }, {
    action: 'ångkoka',
    result: 'ångkokt'
  }, {
    action: 'bränn',
    result: 'bränd'
  }, {
    action: 'hetta upp',
    result: 'upphettad'
  }
]

export const serve = [
  'tillsammans med',
  'på en bädd av',
  'i en fond av',
  'och',
  'med',
  'i en symfoni av',
  'med lite',
  'inlindad i',
  'täckt av',
  'tillagad på'
]

export const prepResults = [
  {
    result: 'ett vitt skum',
    article: 'skummet'
  },
  {
    result: 'småbitar',
    article: 'bitarna'
  },
  {
    result: 'en grynig massa',
    article: 'massan'
  },
  {
    result: 'jämn smet',
    article: 'smeten'
  },
  {
    result: 'en himmelsk konsistens',
    article: 'konsistensen'
  },
  {
    result: 'en salig röra',
    article: 'röran'
  },
  {
    result: 'ett fint mjöl',
    article: 'resultatet'
  },
  {
    result: 'klumpfri smet',
    article: 'smeten'
  },
  {
    result: 'klumpigt gojs',
    article: 'gojset'
  },
  {
    result: 'en fond',
    article: 'fonden'
  },
  {
    result: 'runda bitar',
    article: 'bitarna'
  },
  {
    result: 'stavar',
    article: 'stavarna'
  },
  {
    result: 'centimetertjocka skivor',
    article: 'skivorna'
  },
  {
    result: 'tjocka klumpar',
    article: 'klumparna'
  }
]

export const cookResults = [
  'gyllenbrun',
  'svart',
  'genomstekt',
  'klar',
  'tjock',
  'god',
  'ljuv',
  'saftig',
  'mosig',
  'torr',
  'halvklar',
  'smörig'
]



// WEBPACK FOOTER //
// ./src/data/index.js